import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationIR extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code') {
    super(/^[A-Z]\d{2}$/i, errorMessage);
  }
}
